import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    getFormFromFormListById,
    getListCustomFiledOfForm,
    isTicketCountNumber,
    unregisterField,
    updateLimitNumOfTicket,
    filterQaRequestForms
} from './TicketHandler';
import { getFormFieldData, copyFileOfTicketDraftTo, handleUploadFilesForTicket } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import {
    onCreateInvitationGuestProjectTicketHandler,
    onSaveDraftInvitationGuestProjectTicketHandler
} from './InvitationGuestProjectTicketHandler';
import { createNoticeTicketHandler, draftNoticeTicketHandler, validateSelectedCustomerBeforeSentTicketNotice } from './NoticeTicketHandler';
import { validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';
import { sortListByOrder } from './TicketHandler';
import {
    onSaveDraftInvitationGuestCustomerTicketHandler,
    onSaveDraftInviteExternalCustomerTicket,
    onSubmitCreateInvitationGuestCustomerTicket,
    onSubmitCreateInviteExternalCustomerTicket
} from './InvitationGuestCustomerTicketHandler';
import {
    handleCreateDelegateTicketSubmit,
    onSaveDraftDelegateTicketHandler,
    onSelectProjectDelegate
} from './DelegateTicketHandler';
import {
    isInputAllFieldRequired,
    isInputValueInCustomForm,
    updateUsingTicketOfFormListState
} from './CreateTicketCommonHandler';
import I18n from '@/rI18n';
import { filterExternalCustomerProject } from '@/service/projectService';
import { TmpHiddenSysfieldInCreateTicket } from '../../../common/constant/SystemField';
import { cloneDeep } from 'lodash';
import { TmpHiddenSysFieldInTicketDetail } from '@/common/constant/SystemField';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { createKibanaDataContentOperation } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import {
    createNewTicketAPI,
    saveDraftTicketAPI,
} from '@/service/ticketService';
import { removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import { updateUserWorkLastForm } from '@/common/utils/ServiceFactoryUtil';
import { getItemFieldListByFieldId } from '@/service/formManagementService';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

const externalCustomerProjectInitErrObj = {
    error: false,
    helperText: ''
};
const externalCustomerProjectErrObj = {
    error: true,
    helperText: 'COMMSG001'
};

export const submitOnChangeTicketType = (ticketType, argsAll, isResetData = true) => {
    argsAll.setSelectTicketType(ticketType);

    // if (isResetData) {
    //     unregisterField(argsAll.fieldListData, argsAll.unregisterCreateTicket);
    //     argsAll.setFiledListData([]);
    //     argsAll.setFormList([]);
    //     argsAll.setSelectedForm('');
    //     argsAll.setSelectedFormInfo({});
    //     argsAll.setValueCreateTicket('');
    //     argsAll.setIsLoading(false);
    //     argsAll.setSelectedAssigneeUserId('');

    //     // Reset attact file
    //     argsAll.setValueCreateTicket(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, []);
    //     argsAll.setFileUploadList([]);

    //     // Update for ticket delegate
    //     argsAll.setGuestProjectSelected({});
    //     argsAll.setGuestUserSelected({});
    //     argsAll.setGuestUserListByProject([]);
    //     argsAll.setValueCreateTicket('projectId', '');
    //     argsAll.setValueCreateTicket('corporationOrigin', '');
    //     argsAll.setValueCreateTicket('guestUserId', '');

    //     // Reset current panel init data
    //     let cloneCurrentPanelInitData = cloneDeep(argsAll.currentPanelInitData);
    //     delete cloneCurrentPanelInitData.formData;
    //     argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
    //     argsAll.setTriggerSaveFormData(Date.now().toString());
    //     argsAll.setIsEdited(true);
    // }
    
    let listFormInProject = argsAll.currentCorporationFormList?.filter(form =>
        form.usingProjects.includes(argsAll.projectInuseDetail.id)
    );

    let formListByTicketType = [];
    switch (ticketType) {
        case Constant.HELPDESK_CREATE_TICKET_TYPE.NOTICE:
            argsAll.setCreateTicketType(Constant.TICKET_TYPE.NOTICE);
            if (!Utils.isEmptyArray(listFormInProject)) {
                formListByTicketType = listFormInProject?.filter(
                    form => form.type === Constant.FORM_TYPE.FORM_REQ_NOTICE
                );
            }

            break;
        case Constant.HELPDESK_CREATE_TICKET_TYPE.DELEGATE:
            argsAll.setCreateTicketType(Constant.TICKET_TYPE.DELEGATE);
            if (!Utils.isEmptyArray(listFormInProject)) {
                formListByTicketType = filterQaRequestForms(listFormInProject);
            }
            break;
        case Constant.HELPDESK_CREATE_TICKET_TYPE.INVITATION_GUEST:
            if (!Utils.isEmptyArray(listFormInProject)) {
                if (Utils.isPublicDesk(argsAll.projectInuseDetail)) {
                    let formReqExternal = listFormInProject.find(t => t.type === Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER)
                    if (formReqExternal) formListByTicketType.push(formReqExternal)
                }
                let formInviteGuestDesk = listFormInProject.find(t => t.type === Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST)
                if (formInviteGuestDesk) formListByTicketType.push(formInviteGuestDesk)
                argsAll.setCreateTicketType(Constant.TICKET_INVITATION_GUEST);
                return argsAll.setFormList(formListByTicketType);
            }

            break;
        case Constant.HELPDESK_CREATE_TICKET_TYPE.TASK:
            argsAll.setCreateTicketType(Constant.TICKET_TYPE.TASK);
            if (!Utils.isEmptyArray(listFormInProject)) {
                formListByTicketType = listFormInProject?.filter(
                    form => form.type === Constant.FORM_TYPE.FORM_TASK
                );
            }
            break;
        case Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL:
            argsAll.setCreateTicketType(Constant.TICKET_TYPE.EMAIL);
            if (!Utils.isEmptyArray(listFormInProject)) {
                formListByTicketType = listFormInProject?.filter(
                    form => form.type === Constant.FORM_TYPE.EMAIL_FORMAT
                );
            }
            break;
        default:
            break;
    }

    formListByTicketType = sortListByOrder(formListByTicketType, argsAll.projectInuseDetail.id);

    argsAll.setFormList(formListByTicketType ? formListByTicketType : []);

    // For email ticket
    if (ticketType === Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL) {
        if (!Utils.isEmptyArray(formListByTicketType) && formListByTicketType[0].affiliationProject === argsAll.projectInuseDetail.id) {
            argsAll.setSelectedForm(formListByTicketType[0].id); 
        }
    }
};

export const handleOnchangeForm = async (e, argsAll, targetFormId = '') => {
    let selectedFormId = e?.target?.dataset?.value;
    if (!selectedFormId && targetFormId) {
        selectedFormId = targetFormId;
    }
    
    if (selectedFormId === argsAll.selectedForm) {
        argsAll.setIsOpenSelectForm(false);
        return;
    }

    if (isInputFormValue(argsAll)) {
        argsAll.setIsConfirmChangeForm(true);
        argsAll.setSelectedFormChange(selectedFormId);
    } else {
        submitOnchangeForm(selectedFormId, argsAll);
    }

    argsAll.setIsOpenSelectForm(false);
};

/**
 * submitOnchangeForm
 * @param {*} selectedFormId
 * @param {*} argsAll
 * @returns
 */
export const submitOnchangeForm = async (selectedFormId, argsAll, formDetail, isKeepLoading = false, initFieldListData) => {
    let fieldListDataResult = [];
    // Reset old value of form, set new form id
    argsAll.setIsLoading(true);
    // User click change form, not init data
    if (!Utils.isEmptyArray(argsAll.fieldListData)) {
        argsAll.resetValuesCreateTicket();
        unregisterField(
            argsAll.fieldListData,
            argsAll.unregisterCreateTicket,
            argsAll.resetValuesCreateTicket
        );

        // Reset attact file
        argsAll.setValueCreateTicket(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, []);
        argsAll.setFileUploadList([]);

        // Reset current panel init data
        let cloneCurrentPanelInitData = cloneDeep(argsAll.currentPanelInitData);
        delete cloneCurrentPanelInitData.formData;
        argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
        argsAll.setTriggerSaveFormData(Date.now().toString());
        argsAll.setIsEdited(true);
    }

    argsAll.registerCreateTicket('fileUploadList');
    argsAll.registerCreateTicket('selectedForm');
    argsAll.setSelectedForm(selectedFormId);
    argsAll.setValueCreateTicket('selectedForm', selectedFormId);
    argsAll.setValueCreateTicket('fileUploadList', []);

    let selectedFormDetail = formDetail;
    if (
        !selectedFormDetail ||
        Utils.isEmptyObject(selectedFormDetail) ||
        formDetail?.id !== selectedFormId
    ) {
        selectedFormDetail = await getFormFromFormListById(selectedFormId);
    }

    if (!Utils.isEmptyObject(selectedFormDetail)) {
        switch (selectedFormDetail.type) {
            case Constant.FORM_TYPE.FORM_REQ_NOTICE:
                argsAll.setCreateTicketType(Constant.TICKET_TYPE.NOTICE);
                break;
            case Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST:
                argsAll.setCreateTicketType(Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT);
                break;
            case Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER:
                argsAll.setCreateTicketType(Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER);
                break;
            case Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER:
                argsAll.setCreateTicketType(Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER);
                break;
            case Constant.FORM_TYPE.FORM_TASK:
                argsAll.setCreateTicketType(Constant.TICKET_TYPE.TASK);
                break;
            case Constant.FORM_TYPE.EMAIL_FORMAT:
                argsAll.setCreateTicketType(Constant.TICKET_TYPE.EMAIL);
                break;
            default:
                argsAll.setCreateTicketType(Constant.TICKET_TYPE.DELEGATE);
                break;
        }

        argsAll.setSelectedFormInfo(selectedFormDetail);
        let getFieldListResult = [];
        if (!Utils.isEmptyArray(initFieldListData)) {
            getFieldListResult = cloneDeep(initFieldListData);
        } else {
            const formStructure = Utils.convertJSONDataToObject(selectedFormDetail?.structure);
            const customFieldList = await getListCustomFiledOfForm(
                formStructure,
                argsAll.API,
                selectedFormDetail.affiliationOrganization
            );
            getFieldListResult = getFormFieldData(formStructure, customFieldList);
        }

        if ([Constant.FORM_TYPE.FORM_REQ_NOTICE].includes(selectedFormDetail.type) || argsAll?.createTicketType === Constant.TICKET_TYPE.DELEGATE) {
            getFieldListResult = Array.from(getFieldListResult, field => {
                field.structure.publicForCustomer = Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE;
                return field;
            });
        }
        
        getFieldListResult = getFieldListResult.filter(
            x =>
                Number(x.structure.publicForCustomer) !==
                    Constant.SETTING_PUBLIC_FOR_CUSTOMER.HIDE ||
                x.type === Constant.FORM_TYPE.FIELD_WORKFLOW
        );

        // filter field not share for corporation of form
        if (selectedFormDetail.definition !== Constant.FORM_DEFINITION.SYSTEM) {
            getFieldListResult = getFieldListResult.filter(x => {
                // sys field auto pass
                if (
                    (x.definition = Constant.FORM_DEFINITION.SYSTEM) ||
                    x.type === Constant.FORM_TYPE.FIELD_WORKFLOW
                ) {
                    return true;
                }

                // get corporation of form
                let currentCorporationDetailId = '';
                if (
                    argsAll?.typeOfTicket === Constant.TICKET_TYPE.NOTICE ||
                    argsAll?.typeOfTicket === Constant.TICKET_TYPE.DELEGATE
                ) {
                    currentCorporationDetailId = argsAll?.corporationDetail?.id
                        ? argsAll?.corporationDetail?.id
                        : localStorageUtil.getAffiliationOrganization();
                } else {
                    currentCorporationDetailId = argsAll?.corporationTarget;
                }

                // field is belong corporation
                if (x.affiliationOrganization === currentCorporationDetailId) {
                    return true;
                }

                // field is shared
                if (currentCorporationDetailId) {
                    let shareRangeOfField = Utils.convertJSONDataToObject(x.shareRange)
                        ? []
                        : Utils.convertJSONDataToObject(x.shareRange);
                    return shareRangeOfField?.includes(currentCorporationDetailId);
                }
                return true;
            });

            // filter field inactive
        getFieldListResult = getFieldListResult.filter(field => {
            let usingProjectOfField = Utils.convertJSONDataToObject(field.usingProjects);
            return usingProjectOfField?.includes(selectedFormDetail.affiliationProject);
        });
        }

        getFieldListResult = Array.from(getFieldListResult, field => {
            if (
                Number(field.structure.publicForCustomer) ===
                Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW
            ) {
                field.structure.publicForCustomer = Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE;
            }

            if (['guestOrg', 'guestProject'].includes(field.sysField)) {
                field.structure.required = true;
            }
            return field;
        });

        if (!Utils.isEmptyArray(initFieldListData)) {
            let newListField = [];
            getFieldListResult.forEach(fieldData => {
                let defaultValue;
                if (fieldData.type === Constant.FORM_TYPE.FIELD_TAG || fieldData.structure?.UI === Constant.FIELD_UI.DROP_FILE) {
                    defaultValue = [];
                } else {
                    defaultValue = '';
                }

                if (fieldData.defaultValue) {
                    defaultValue = fieldData.defaultValue
                } else if (fieldData.value) {
                    defaultValue = fieldData.value
                }

                let fieldDataTmp = {
                    ...fieldData,
                    defaultValue
                };
                if (argsAll.isDraftMode) {
                    fieldDataTmp.structure.publicForCustomer = Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE;
                }
                newListField.push(fieldDataTmp);
            });

            fieldListDataResult = [...newListField];
        } else {
            fieldListDataResult = [...getFieldListResult];
        }

        // Sort by form setting
        let fieldOrderInForm = {};
        let formStructure = Utils.convertJSONDataToObject(selectedFormDetail.structure);
        if (!Utils.isEmptyObject(formStructure)) {
            for (const [structureKey, structureValue] of Object.entries(formStructure)) {
                if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                    fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
                }
            }
        }

        let TmpHiddenSysfieldInCreateTicketDefault = TmpHiddenSysfieldInCreateTicket;
        // Display personInCharge field when create ticket task and email
        if ([Constant.FORM_TYPE.FORM_TASK, Constant.FORM_TYPE.EMAIL_FORMAT].includes(selectedFormDetail.type)) {
            TmpHiddenSysfieldInCreateTicketDefault = TmpHiddenSysfieldInCreateTicketDefault.filter(systemField => systemField !== 'personInCharge');
        }
        switch (selectedFormDetail.type) {
            case Constant.FORM_TYPE.FORM_REQ_NOTICE:
            case Constant.FORM_TYPE.FORM_REQ_QA:
            case Constant.FORM_TYPE.FORM_TASK:
            case Constant.FORM_TYPE.EMAIL_FORMAT:
                fieldListDataResult = fieldListDataResult
                    .filter(
                        field =>
                            !field.sysField ||
                            !TmpHiddenSysfieldInCreateTicketDefault.includes(field.sysField)
                    )
                    .sort((a, b) => {
                        if (!a.order || !b.order) return 1;
                        // attachment always at bottom
                        if (a.sysField === 'attachments') return 1;
                        if (b.sysField === 'attachments') return -1;

                        if (!Utils.isEmptyObject(fieldOrderInForm)) {
                            return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                        }

                        return 1;
                    });
                break;
            default:
                break;
        }

        argsAll.setFiledListData([...fieldListDataResult]);

        if (selectedFormDetail?.type === Constant.FORM_TYPE.EMAIL_FORMAT && !Utils.isEmptyArray(fieldListDataResult) && argsAll.registerCreateTicket) {
            fieldListDataResult.forEach(field => {
                argsAll.registerCreateTicket(field?.id)
            })
        }
    }

    if (!isKeepLoading) {
        argsAll.setIsLoading(false);
    }
    return {
        fieldListData: fieldListDataResult
    }
};

/**
 * handleCloseSelectForm
 * @param {*} argsAll
 */
export const handleCloseSelectForm = argsAll => {
    argsAll.setIsOpenSelectForm(false);
};

export const onSubmitCreateTicket = async (formData, argsAll, forceCreate) => {
    let newTicket = {};
    switch (argsAll.createTicketType) {
        case Constant.TICKET_TYPE.NOTICE:
            newTicket = await createNoticeTicketHandler(
                formData,
                argsAll.userDetail,
                argsAll.panelId,
                argsAll.panelType,
                argsAll.tabId,
                argsAll.corporationDetail,
                argsAll.selectedForm,
                argsAll.fieldListData,
                argsAll
            );
            break;
        case Constant.TICKET_TYPE.DELEGATE:
            newTicket = await handleCreateDelegateTicketSubmit(formData, argsAll);
            break;
        case Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT:
            const fields = await Utils.getCustomFieldValueInFormData(formData, argsAll.fieldListData);

            newTicket = await onCreateInvitationGuestProjectTicketHandler(
                argsAll,
                formData,
                argsAll.userDetail,
                argsAll.panelId,
                argsAll.panelType,
                argsAll.tabId,
                argsAll.corporationDetail,
                argsAll.selectedForm,
                fields,
                forceCreate
            );
            break;
        case Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER:
            newTicket = await onSubmitCreateInvitationGuestCustomerTicket(
                argsAll,
                formData,
                argsAll.userDetail,
                argsAll.panelId,
                argsAll.panelType,
                argsAll.tabId,
                argsAll.corporationDetail,
                argsAll.selectedForm,
                argsAll.setErrorCreateTicket
            );
            break;
        case Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER:
            newTicket = await onSubmitCreateInviteExternalCustomerTicket(
                argsAll,
                formData,
                argsAll.panelId,
                argsAll.panelType,
                argsAll.tabId
            );
            break;
        case Constant.TICKET_TYPE.TASK:
            newTicket = await createTaskTicketHandler(
                formData,
                argsAll.userDetail,
                argsAll.panelId,
                argsAll.panelType,
                argsAll.tabId,
                argsAll.corporationDetail,
                argsAll.selectedForm,
                argsAll.fieldListData,
                argsAll
            );
            break;
        case Constant.TICKET_TYPE.EMAIL:
            newTicket = await createEmailTicketHandler(
                formData,
                argsAll.userDetail,
                argsAll.panelId,
                argsAll.panelType,
                argsAll.tabId,
                argsAll.corporationDetail,
                argsAll.selectedForm,
                argsAll.fieldListData,
                argsAll
            );
            break;
        default:
            break;
    }

    //update usingTicket of formList
    if (!Utils.isEmptyObject(newTicket)) {
        updateUsingTicketOfFormListState(
            argsAll.currentCorporationFormList,
            argsAll.setCurrentCorporationFormList,
            argsAll.selectedForm,
            newTicket
        );
        argsAll.setIsEdited(false);
    }

    if(isTicketCountNumber(argsAll.createTicketType)) {
        updateLimitNumOfTicket(argsAll);
    }
};



export const onSubmitSaveDraftTicket = async (formData, argsAll) => {
    let newTicket;
    switch (argsAll.createTicketType) {
        case Constant.TICKET_TYPE.NOTICE:
            newTicket = await draftNoticeTicketHandler(
                formData,
                argsAll.userDetail,
                argsAll.corporationDetail,
                argsAll.selectedForm,
                argsAll.fieldListData,
                argsAll
            );
            break;
        case Constant.TICKET_TYPE.DELEGATE:
            newTicket = await onSaveDraftDelegateTicketHandler(formData, argsAll);
            break;
        case Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT:
            const fields = await Utils.getCustomFieldValueInFormData(formData, argsAll.fieldListData);
            newTicket = await onSaveDraftInvitationGuestProjectTicketHandler(
                argsAll,
                formData,
                argsAll.userDetail,
                argsAll.corporationDetail,
                argsAll.selectedForm,
                fields
            );
            break;
        case Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER:
            newTicket = await onSaveDraftInvitationGuestCustomerTicketHandler(
                argsAll,
                formData,
                argsAll.userDetail,
                argsAll.corporationDetail,
                argsAll.selectedForm
            );
            break;
        case Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER:
            newTicket = await onSaveDraftInviteExternalCustomerTicket(
                argsAll,
                formData,
                argsAll.panelId,
                argsAll.panelType,
                argsAll.tabId
            );
            break;
        case Constant.TICKET_TYPE.TASK:
            newTicket = await draftTaskTicketHandler(
                formData,
                argsAll.userDetail,
                argsAll.corporationDetail,
                argsAll.selectedForm,
                argsAll.fieldListData,
                argsAll
            );
            break;
        case Constant.TICKET_TYPE.EMAIL:
            newTicket = await draftEmailTicketHandler(
                formData,
                argsAll.userDetail,
                argsAll.corporationDetail,
                argsAll.selectedForm,
                argsAll.fieldListData,
                argsAll
            );
            break;
        default:
            break;
    }

    if (!Utils.isEmptyObject(newTicket)) {
        argsAll?.setDisplayMode(Constant.DISPLAY_MODE.VIEW);

        setTimeout(() => {
            let tabId = argsAll.tabId;
            if (!tabId) {
                tabId = argsAll.ticketId;
            }
            argsAll.updatePanelInitData(
                argsAll.panelId,
                argsAll.tabId,
                null,
                argsAll.setPanelInitData,
                'isEditedData',
                false
            );
            argsAll.updatePanelAfterCreateTicket({
                panelId: argsAll.panelId,
                tabId: tabId,
                panelType: argsAll.panelType,
                ticketId: newTicket?.id,
                ticketOutline: newTicket?.outline,
                isDraft: true,
                API: argsAll.API
            });
            argsAll.setIsLoading(false);
        }, 300);
        argsAll.setLastUserAction(null);
        updateUsingTicketOfFormListState(
            argsAll.currentCorporationFormList,
            argsAll.setCurrentCorporationFormList,
            argsAll.selectedForm,
            newTicket
        );

        argsAll.setIsEdited(false);
        argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-CM-SAVE-DRAFT-TICKET-SUCCESS'), {
            variant: 'success',
            autoHideDuration: 3000,
        });
    }
};

/**
 * isInputFormValue
 * @param {*} argsAll
 * @returns
 */
export const isInputFormValue = argsAll => {
    if (
        !argsAll.selectedForm ||
        Utils.isEmptyArray(argsAll.fieldListData) ||
        Utils.isEmptyObject(argsAll.selectedFormInfo)
    ) {
        return false;
    }

    let isInputData = false;

    // is selected AssigneeUserId
    let isSelectedAssigneeUserId = !Utils.isEmptyString(argsAll.selectedAssigneeUserId)
    if (isSelectedAssigneeUserId) {
        return true;
    }

    // is uploaded file
    let uploadList = argsAll.getValuesCreateTicket('fileUploadList');
    if (!Utils.isEmptyArray(uploadList)) {
        return true;
    }

    for (const field of argsAll.fieldListData) {
        let fieldId = field.id;
        let fieldValue = argsAll.getValuesCreateTicket(fieldId);

        if (
            (argsAll.selectedFormInfo.definition === Constant.FORM_DEFINITION.SYSTEM &&
                isInputValueInSystemForm(
                    argsAll.selectedFormInfo,
                    field,
                    fieldValue,
                    argsAll.externalCustomerRequestProject
                )) ||
            ([
                Constant.FORM_DEFINITION.USER,
                Constant.FORM_DEFINITION.MASTER,
                Constant.FORM_DEFINITION.SYSTEM_MASTER_FIELD
            ].includes(argsAll.selectedFormInfo.definition) &&
                isInputValueInCustomForm(field, fieldValue))
                || (argsAll.selectedFormInfo.type === Constant.FORM_TYPE.EMAIL_FORMAT && (isInputValueInCustomForm(field, fieldValue) || argsAll.isEdited))
        ) {
            isInputData = true;
            break;
        }
    }

    return isInputData;
};

/**
 * isInputValueInSystemForm
 * validate is input value in system form
 * @param {*} formInfo
 * @param {*} field
 * @param {*} fieldValue
 * @param {*} externalDeskRequestProject
 * @returns
 */
const isInputValueInSystemForm = (formInfo, field, fieldValue, externalCustomerRequestProject) => {
    let systemFieldId = field.sysField;
    let isInputValue = false;
    switch (formInfo.type) {
        // Default QA
        case Constant.FORM_TYPE.FORM_REQ_QA:
            if (systemFieldId === 'field_qa_category') {
                if (
                    fieldValue.length !== 1 ||
                    fieldValue[0].value !== 'field_qa_category_tag_requirement'
                ) {
                    isInputValue = true;
                }
            } else if (fieldValue) {
                isInputValue = true;
            }
            break;

        case Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST:
            if (fieldValue) {
                fieldValue = fieldValue.trim();
            }

            if (
                (systemFieldId === 'outline' &&
                    fieldValue !== Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUESTDESK.OUTLINE) ||
                (systemFieldId === 'category' &&
                    fieldValue !== Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST.CATEGORY) ||
                (systemFieldId === 'description' &&
                    fieldValue !== Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST.DESCRIPTION) ||
                (!['outline', 'category', 'description'].includes(systemFieldId) && fieldValue)
            ) {
                isInputValue = true;
            }

            break;

        case Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER:
            if (fieldValue) {
                fieldValue = fieldValue.trim();
            }

            if (
                (systemFieldId === 'outline' &&
                    fieldValue !== Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUESTDESK.OUTLINE) ||
                (systemFieldId === 'category' &&
                    fieldValue !==
                        Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST_CUSTOMER.CATEGORY) ||
                (systemFieldId === 'description' &&
                    fieldValue !== Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUEST.DESCRIPTION) ||
                (!['outline', 'category', 'description'].includes(systemFieldId) && fieldValue)
            ) {
                isInputValue = true;
            }

            break;

        case Constant.FORM_TYPE.FORM_REQ_EXTERNAL_CUSTOMER:
            if (fieldValue) {
                fieldValue = fieldValue.trim();
            }

            if (
                (systemFieldId === 'outline' &&
                    fieldValue !==
                        Constant.CREATE_TICKET_DEFAULT_VALUE.REQUEST_EXTERNAL_CUSTOMER.OUTLINE) ||
                (systemFieldId === 'category' &&
                    fieldValue !==
                        Constant.CREATE_TICKET_DEFAULT_VALUE.REQUEST_EXTERNAL_CUSTOMER.CATEGORY) ||
                (systemFieldId === 'description' && fieldValue) ||
                !Utils.isEmptyObject(externalCustomerRequestProject)
            ) {
                isInputValue = true;
            }

            break;
        default:
            break;
    }

    return isInputValue;
};

export const checkIsDisableBtnSend = argsAll => {
    // check selected create ticket type and select form
    if (
        !argsAll.createTicketType ||
        !argsAll.selectedForm ||
        Utils.isEmptyArray(argsAll.fieldListData) ||
        !Utils.isEmptyObject(argsAll.errorCreateTicket)
    ) {
        return true;
    }

    // Validate email ticket
    if (argsAll.createTicketType === Constant.TICKET_TYPE.EMAIL) {
        if (Utils.isEmptyArray(argsAll.toEmailAddressList)) {
            return true;
        } else {
            let toList = processEmailAddressList(argsAll.toEmailAddressList);
            if (Utils.isEmptyArray(toList)) return true;
            
            // check input all fields required
            if (!isInputAllFieldRequired(argsAll.fieldListData, argsAll.getValuesCreateTicket, argsAll.fileUploadList)) {
                return true;
            }

            // Validate attachment field
            if (!Utils.isEmptyObject(argsAll.errorCreateTicket)) {
                let fieldAttachData = argsAll?.fieldListData.find(field => field.sysField === Constant.SYS_FIELD.ATTACHMENTS);
                if (!Utils.isEmptyObject(fieldAttachData) && argsAll.errorCreateTicket.hasOwnProperty(fieldAttachData.id) && argsAll.errorCreateTicket[fieldAttachData.id].message) {
                    return true;
                }
            }

            return false;
        }
    }

    // check if error create Ticket is guest project
    if (argsAll.createTicketType === Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT && !Utils.isEmptyObject(argsAll.errorCreateTicket)) {
        return true
    }
    // Check for delegate ticket
    if (
        argsAll.createTicketType === Constant.TICKET_TYPE.DELEGATE &&
        (Utils.isEmptyObject(argsAll.guestProjectSelected) ||
            ([Constant.PROJECT_TYPE.BASE, Constant.PROJECT_TYPE.CUSTOMER].includes(
                argsAll.guestProjectSelected.type
            ) &&
                Utils.isEmptyObject(argsAll.guestUserSelected)))
    ) {
        return true;
    }

    // Check for ticket external customer request
    if (
        argsAll.createTicketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER &&
        (Utils.isEmptyObject(argsAll.externalCustomerRequestProject) ||
            !argsAll.externalCustomerRequestProject.value)
    ) {
        return true;
    }

    // Check for ticket notice
    if (argsAll.createTicketType === Constant.TICKET_TYPE.NOTICE && !validateSelectedCustomerBeforeSentTicketNotice(argsAll)) {
        return true;
    }

    // check input all fields required
    if (!isInputAllFieldRequired(argsAll.fieldListData, argsAll.getValuesCreateTicket, argsAll.fileUploadList)) {
        return true;
    }

    return false;
};

/**
 * checkIsDisableBtnDraft
 * @param {*} argsAll
 * @returns
 */
export const checkIsDisableBtnDraft = argsAll => {
    if (!argsAll.createTicketType || !argsAll.selectedForm) {
        return true;
    }
    
    if (argsAll.createTicketType === Constant.TICKET_TYPE.DELEGATE) {
        if (Utils.isEmptyObject(argsAll.guestProjectSelected)) {
            return true;
        }

        if (
            [Constant.PROJECT_TYPE.BASE, Constant.PROJECT_TYPE.CUSTOMER].includes(
                argsAll.guestProjectSelected.type
            ) &&
            Utils.isEmptyObject(argsAll.guestUserSelected)
        ) {
            return true;
        }
    }

    // Check for ticket external customer request
    if (
        argsAll.createTicketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER &&
        (Utils.isEmptyObject(argsAll.externalCustomerRequestProject) ||
            !argsAll.externalCustomerRequestProject.value)
    ) {
        return true;
    }

    // Ticket draft not edit
    if (argsAll.isDraftMode && !argsAll.isEdited) {
        return true;
    }

    return false;
};

/**
 * get option label display on input
 * @param {*} option
 * @param {*} externalCustomerRequestKeyword
 * @returns
 */
export const getOptionSearchLabel = (option, externalCustomerRequestKeyword) => {
    let optionLabel = '';

    if (option && option.label) {
        optionLabel = option.label;
    } else if (externalCustomerRequestKeyword) {
        optionLabel = externalCustomerRequestKeyword;
    }
    return optionLabel;
};

/**
 * onchange input search external customer
 * @param {*} e
 * @param {*} argsAll
 */
export const onChangeExternalCustomerInput = (e, argsAll) => {
    let keyword = e.target.value;
    // helperText holds a locale key or Japanese source text; the component resolves and translates it on render
    let msgKeywordMaxLength = I18n.get('COMMSG022').replace('{{maxLength}}', '2000');

    if (keyword.length > 2000) {
        argsAll.setExternalCustomerProjectErr({
            error: true,
            helperText: msgKeywordMaxLength
        });
    } else if (
        argsAll.externalCustomerProjectErr?.error &&
        argsAll.externalCustomerProjectErr?.helperText === msgKeywordMaxLength
    ) {
        argsAll.setExternalCustomerProjectErr({
            error: false,
            helperText: ''
        });
    }

    argsAll.setExternalCustomerRequestKeyword(keyword);
    argsAll.setOpenExternalCustomerList(false);
    if (!keyword) {
        argsAll.setExternalCustomerRequestProject({});
    }
};

/**
 * searchExternalCustomerProject
 *
 * @param {*} argsAll
 * @param {*} keyword
 * @returns
 */
export const searchExternalCustomerProject = async (argsAll, keyword) => {
    try {
        // reset before search
        argsAll.setExternalCustomerRequestProject({});
        argsAll.setOpenExternalCustomerList(false);
        // argsAll.setExternalCustomerRequestKeyword('');

        if (!keyword) {
            argsAll.setExternalCustomerProjectList([]);
            argsAll.setExternalCustomerProjectErr(externalCustomerProjectErrObj);
            return;
        }
        keyword = keyword.trim();
        argsAll.setExternalCustomerProjectErr(externalCustomerProjectInitErrObj);

        argsAll.setIsLoading(true);

        let projectId = argsAll.projectInuseDetail.id;
        let corporationId = argsAll.projectInuseDetail.affiliationOrganization;
        let resProjectList = await filterExternalCustomerProject(
            argsAll.API,
            projectId,
            corporationId,
            keyword
        );
        if (Utils.isEmptyArray(resProjectList)) {
            argsAll.setExternalCustomerProjectList([]);
            argsAll.setExternalCustomerProjectErr(externalCustomerProjectErrObj);
            argsAll.setIsLoading(false);
            return;
        }

        // Sort list project
        resProjectList = Utils.sortByCreatedAtDesc(resProjectList);

        let projectList = [];
        resProjectList.forEach(project => {
            let corporationName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                project.corporationData.name
            );
            let projectName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, project.name);

            let projectOption = {
                value: project.id,
                label: `${projectName} (${corporationName})`,
                corporationId: project.corporationData.id
            };
            projectList.push(projectOption);
        });

        argsAll.setExternalCustomerProjectList(projectList);
        argsAll.setIsLoading(false);
        argsAll.setOpenExternalCustomerList(true);
    } catch (error) {
        console.log('searchExternalCustomerProject ========', error);
        argsAll.setExternalCustomerProjectList([]);
        argsAll.setExternalCustomerProjectErr(externalCustomerProjectErrObj);
        argsAll.setOpenExternalCustomerList(false);
        argsAll.setIsLoading(false);
    }
};

/**
 *
 * @param {*} argsAll
 * @param {*} project
 * @returns
 */
export const selectExternalCustomerProject = (argsAll, project) => {
    if (Utils.isEmptyObject(project) || !project.value) {
        return;
    }

    argsAll.setExternalCustomerRequestProject(project);
    argsAll.setExternalCustomerRequestKeyword(project.label);
    argsAll.setOpenExternalCustomerList(false);
    argsAll.setExternalCustomerProjectErr({
        error: false,
        helperText: ''
    });
    argsAll.setIsEdited(true);
};

/**
 * key press search guest customer prj
 * @param {*} e
 * @param {*} argsAll
 * @param {*} keyword
 * @returns
 */
export const onKeyPressSearchExternalCustomerProject = (e, argsAll, keyword) => {
    if (e.key !== 'Enter') {
        return;
    }

    searchExternalCustomerProject(argsAll, keyword);
};

/**
 * onBlurExternalCustomerInput
 * @param {*} e
 * @param {*} argsAll
 */
export const onBlurExternalCustomerInput = (e, argsAll) => {
    if (
        !argsAll.externalCustomerRequestKeyword ||
        Utils.isEmptyObject(argsAll.externalCustomerRequestProject)
    ) {
        argsAll.setExternalCustomerProjectErr({
            error: true,
            helperText: 'COMMSG014'
        });
    }
};

/**
 * initDataPanelCreateTicketHelpdeskSide
 * @param {*} currentPanelInitDataRes
 * @param {*} argsAll
 */
export const initDataPanelCreateTicketHelpdeskSide = async (currentPanelInitDataRes, argsAll) => {
    let oldArgsAll = currentPanelInitDataRes.argsAll;
    if (!oldArgsAll || Utils.isEmptyObject(oldArgsAll)) {
        return;
    }
    argsAll.setIsInitOldData(true);

    if (currentPanelInitDataRes.isEditedData) {
        argsAll.setIsEdited(true);
    } else {
        argsAll.setIsEdited(false);
    }

    if (oldArgsAll.selectTicketType) {
        // Ticket type
        submitOnChangeTicketType(oldArgsAll.selectTicketType, argsAll, false);
    }

    // Ticket external customer request ticket
    if (
        oldArgsAll.externalCustomerProjectList &&
        !Utils.isEmptyArray(oldArgsAll.externalCustomerProjectList)
    ) {
        argsAll.setExternalCustomerProjectList(oldArgsAll.externalCustomerProjectList);
    }
    if (
        oldArgsAll.externalCustomerRequestProject &&
        !Utils.isEmptyObject(oldArgsAll.externalCustomerRequestProject)
    ) {
        argsAll.setExternalCustomerRequestProject(oldArgsAll.externalCustomerRequestProject);
        argsAll.setOpenExternalCustomerList(false);
        argsAll.setExternalCustomerProjectErr({
            error: false,
            helperText: ''
        });
    }

    // delegate ticket.
    if (
        oldArgsAll.guestProjectList &&
        !Utils.isEmptyArray(oldArgsAll.guestProjectList)
    ) {
        argsAll.setGuestProjectList(oldArgsAll.guestProjectList);
    }
    if (
        oldArgsAll.guestUserListByProject &&
        !Utils.isEmptyArray(oldArgsAll.guestUserListByProject)
    ) {
        argsAll.setGuestUserListByProject(oldArgsAll.guestUserListByProject);
    }
    if (oldArgsAll.guestUserSelected && !Utils.isEmptyObject(oldArgsAll.guestUserSelected)) {
        argsAll.setGuestUserSelected(oldArgsAll.guestUserSelected);
    }
    if (oldArgsAll.guestProjectSelected && !Utils.isEmptyObject(oldArgsAll.guestProjectSelected)) {
        let cloneArgsAll = cloneDeep(argsAll);
        if (oldArgsAll.guestProjectList && !Utils.isEmptyArray(oldArgsAll.guestProjectList)) {
            cloneArgsAll.guestProjectList = oldArgsAll.guestProjectList;
        }
        await onSelectProjectDelegate(oldArgsAll.guestProjectSelected?.id, cloneArgsAll, false);
    }

    // Ticket notice
    let methodNotice = 0;
    if (oldArgsAll.methodNotice) {
        methodNotice = oldArgsAll.methodNotice;
    }
    argsAll.setMethodNotice(methodNotice);

    if (oldArgsAll.listExternalCustomerProject && !Utils.isEmptyArray(oldArgsAll.listExternalCustomerProject)) {
        argsAll.setListExternalCustomerProject(oldArgsAll.listExternalCustomerProject);
    }
    if (oldArgsAll.listCustomerUser && !Utils.isEmptyArray(oldArgsAll.listCustomerUser)) {
        argsAll.setListCustomerUser(oldArgsAll.listCustomerUser);
    }
    if (oldArgsAll.noticeCustomer) {
        argsAll.setNoticeCustomer(oldArgsAll.noticeCustomer);
    }
    if (oldArgsAll.noticeCustomerList && !Utils.isEmptyArray(oldArgsAll.noticeCustomerList)) {
        argsAll.setNoticeCustomerList(oldArgsAll.noticeCustomerList);
    }   
    if (oldArgsAll.baseProject && !Utils.isEmptyArray(oldArgsAll.baseProject)) {
        argsAll.setBaseProject(oldArgsAll.baseProject);
    }
    if (oldArgsAll.guestCustomerProject && !Utils.isEmptyArray(oldArgsAll.guestCustomerProject)) {
        argsAll.setGuestCustomerProject(oldArgsAll.guestCustomerProject);
    }

    // Selected form
    if (oldArgsAll.selectedForm) {
        await submitOnchangeForm(oldArgsAll.selectedForm, argsAll, null, true, oldArgsAll.fieldListData);
    }

    // File upload
    let fileUploadListOld = oldArgsAll.fileUploadList;
    if (!Utils.isEmptyArray(fileUploadListOld)) {
        argsAll.setFileUploadList(fileUploadListOld);
        argsAll.setValueCreateTicket('fileUploadList', fileUploadListOld);
    }

    // File upload
    let fileUpdatedListOld = oldArgsAll.fileUpdatedList;
    if (!Utils.isEmptyArray(fileUpdatedListOld)) {
        argsAll.setFileUpdatedList(fileUpdatedListOld);
        argsAll.setValueCreateTicket('fileUpdatedList', fileUpdatedListOld);
    }

    // File upload
    let fileUploadingOld = oldArgsAll.fileUploading;
    if (!Utils.isEmptyArray(fileUploadingOld)) {
        argsAll.setfileUploading(fileUploadingOld);
        argsAll.setValueCreateTicket('fileUploading', fileUploadingOld);
    }

    // Assignee
    if (oldArgsAll.selectedAssigneeUserId && !Utils.isEmptyArray(oldArgsAll.selectedAssigneeUserId)) {
        argsAll.setSelectedAssigneeUserId(oldArgsAll.selectedAssigneeUserId);
    }

    // Email ticket
    if (oldArgsAll.toEmailAddressList && !Utils.isEmptyArray(oldArgsAll.toEmailAddressList) && argsAll.setToEmailAddressList) {
        argsAll.setToEmailAddressList(oldArgsAll.toEmailAddressList);
    }
    if (oldArgsAll.ccEmailAddressList && !Utils.isEmptyArray(oldArgsAll.ccEmailAddressList) && argsAll.setCcEmailAddressList) {
        argsAll.setCcEmailAddressList(oldArgsAll.ccEmailAddressList);
    }
    if (oldArgsAll.bccEmailAddressList && !Utils.isEmptyArray(oldArgsAll.bccEmailAddressList) && argsAll.setBccEmailAddressList) {
        argsAll.setBccEmailAddressList(oldArgsAll.bccEmailAddressList);
    }
    if (oldArgsAll.listSuggestSearchEmail && !Utils.isEmptyArray(oldArgsAll.listSuggestSearchEmail) && argsAll.setListSuggestSearchEmail) {
        argsAll.setListSuggestSearchEmail(oldArgsAll.listSuggestSearchEmail);
    }

    // status field
    if (argsAll.setStatusNo) {
        argsAll.setStatusNo(oldArgsAll?.statusNo || 0);
    }

    argsAll.setIsEdited(false);
}


/**
 * initDataTicketDraftHelpdeskSide
 * @param {*} argsAll 
 * @returns 
 */
export const initDataTicketDraftHelpdeskSide = (argsAll, currentPanelInitDataRes)  => {
    if (!argsAll.detailTicket || Utils.isEmptyObject(argsAll.detailTicket)) return;
    let detailTicket = argsAll.detailTicket;

    if (!Utils.isEmptyString(currentPanelInitDataRes?.displayMode) && argsAll?.setDisplayMode) {
        argsAll?.setDisplayMode(currentPanelInitDataRes?.displayMode);
    }
    const oldArgsAll = currentPanelInitDataRes?.argsAll; 
    let cloneCurrentPanelInitData = cloneDeep(argsAll.currentPanelInitData);
    // Ticket type
    let ticketType = detailTicket.ticketType;
    switch (ticketType) {
        case Constant.TICKET_TYPE.BROADCAST_PARENT:
        case Constant.TICKET_TYPE.BROADCAST_CHILD:
            submitOnChangeTicketType(Constant.HELPDESK_CREATE_TICKET_TYPE.NOTICE, argsAll, false);
            break;
        case Constant.TICKET_TYPE.DELEGATE: {
            if (oldArgsAll) {
                if (
                    oldArgsAll?.guestProjectList &&
                    !Utils.isEmptyArray(oldArgsAll?.guestProjectList)
                ) {
                    argsAll.setGuestProjectList(oldArgsAll.guestProjectList);
                }

                if (
                    oldArgsAll.guestProjectSelected &&
                    !Utils.isEmptyObject(oldArgsAll.guestProjectSelected)
                ) {
                    let cloneArgsAll = cloneDeep(argsAll);
                    if (
                        oldArgsAll.guestProjectList &&
                        !Utils.isEmptyArray(oldArgsAll.guestProjectList)
                    ) {
                        cloneArgsAll.guestProjectList = oldArgsAll.guestProjectList;
                    }
                    onSelectProjectDelegate(
                        oldArgsAll.guestProjectSelected?.id,
                        cloneArgsAll,
                        false
                    ).then(data => {});
                }

                if (
                    oldArgsAll.guestUserSelected &&
                    !Utils.isEmptyObject(oldArgsAll.guestUserSelected)
                ) {
                    argsAll.setGuestUserSelected(oldArgsAll.guestUserSelected);
                }

                const selectedAssigneeUserIdDraftValue = oldArgsAll?.selectedAssigneeUserId;
                argsAll.setSelectedAssigneeUserId(selectedAssigneeUserIdDraftValue || '');
            }
            
            submitOnChangeTicketType(Constant.HELPDESK_CREATE_TICKET_TYPE.DELEGATE, argsAll, false);
            break;
        }
        case Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT:
        case Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER:
            // isKeepLoading = false;
            submitOnChangeTicketType(
                Constant.HELPDESK_CREATE_TICKET_TYPE.INVITATION_GUEST,
                argsAll,
                false
            );
            break;
        case Constant.TICKET_TYPE.EMAIL: {
            const toDraftFieldValue = oldArgsAll?.toEmailAddressList;
            const ccDraftFieldValue = oldArgsAll?.ccEmailAddressList;
            const bccDraftFieldValue = oldArgsAll?.bccEmailAddressList;
            const selectedAssigneeUserIdDraftValue = oldArgsAll?.selectedAssigneeUserId;

            cloneCurrentPanelInitData = {
                ...cloneCurrentPanelInitData,
                argsAll: {
                    ...(cloneCurrentPanelInitData?.argsAll || {}),
                    toDraftFieldValue: toDraftFieldValue,
                    ccDraftFieldValue: ccDraftFieldValue,
                    bccDraftFieldValue: bccDraftFieldValue,
                    selectedAssigneeUserIdDraftValue
                }
            };
            argsAll.setSelectedAssigneeUserId(selectedAssigneeUserIdDraftValue || '');
            submitOnChangeTicketType(Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL, argsAll, false);
            break;
        }
        case Constant.TICKET_TYPE.TASK: {
            const selectedAssigneeUserIdDraftValue = oldArgsAll?.selectedAssigneeUserId;
            cloneCurrentPanelInitData = {
                ...cloneCurrentPanelInitData,
                argsAll: {
                    ...(cloneCurrentPanelInitData?.argsAll || {}),
                    selectedAssigneeUserIdDraftValue
                }
            };
            argsAll.setSelectedAssigneeUserId(selectedAssigneeUserIdDraftValue || '');
            submitOnChangeTicketType(
                Constant.HELPDESK_CREATE_TICKET_TYPE.TASK,
                argsAll,
                false
            );
            break;
        }
        default:
            break;
    }

    // Form
    if (argsAll.draftData?.formDetail && argsAll.draftData?.fieldListData) {
        let fieldListData = Utils.convertJSONDataToObject(argsAll.draftData.fieldListData);
        // Form detail
        let formDetail = Utils.convertJSONDataToObject(argsAll.draftData.formDetail);
        let selectedFormId = formDetail.id;
        if (
            !Utils.isEmptyString(currentPanelInitDataRes?.formData?.selectedForm) &&
            currentPanelInitDataRes.isEditedData
        ) {
            selectedFormId = currentPanelInitDataRes?.formData?.selectedForm;
            submitOnchangeForm(selectedFormId, argsAll, formDetail, false, [])
                .then(data => {
                    let { fieldListData: fieldListDataChangeTab } = data;
                    fieldListData = fieldListDataChangeTab;
                })
                .finally(() => {
                    // do nothing
                });
        } else {
            submitOnchangeForm(selectedFormId, argsAll, formDetail, false, fieldListData);
        }

        // Form data
        let objFormData =
            cloneCurrentPanelInitData?.formData &&
            !Utils.isEmptyObject(cloneCurrentPanelInitData?.formData)
                ? cloneCurrentPanelInitData?.formData
                : {};
        if (!Utils.isEmptyArray(fieldListData)) {
            fieldListData.forEach(field => {
                if (TmpHiddenSysFieldInTicketDetail.includes(field.sysField)) return;

                const currentFormData = currentPanelInitDataRes?.formData;
                const isFieldEdited =
                    !Utils.isEmptyObject(currentFormData) &&
                    currentFormData.hasOwnProperty(field?.id) &&
                    currentPanelInitDataRes?.isEditedData &&
                    (currentPanelInitDataRes?.argsAll?.displayMode === Constant.DISPLAY_MODE.EDIT ||
                    currentPanelInitDataRes?.displayMode === Constant.DISPLAY_MODE.EDIT)
                

                if (field.type === Constant.FORM_TYPE.FIELD_TAG) {
                    let defaultSelectedTag = [];
                    if (!Utils.isEmpty(field?.defaultValue)) {
                        defaultSelectedTag = field.defaultValue;
                    } 

                    if (isFieldEdited) {
                        defaultSelectedTag = currentFormData[field?.id];
                    }
                    objFormData[field.id] = defaultSelectedTag;
                } else {
                    let fieldValue = field.value;

                    if (isFieldEdited) {
                        fieldValue = currentFormData[field?.id];
                    }
                    objFormData[field.id] = fieldValue;
                }
            });
            
            cloneCurrentPanelInitData.formData = objFormData;

            if ([Constant.TICKET_TYPE.TASK, Constant.TICKET_TYPE.EMAIL].includes(ticketType)) {
                let statusDetail = Utils.convertJSONDataToObject(detailTicket.statusDetail);
                if (
                    currentPanelInitDataRes?.isEditedData &&
                    currentPanelInitDataRes?.argsAll?.displayMode === Constant.DISPLAY_MODE.EDIT &&
                    statusDetail?.no !== currentPanelInitDataRes?.argsAll?.statusNo
                ) {
                    getItemFieldListByFieldId(
                        argsAll?.API,
                        Constant.FORM_USAGE.STATUS,
                        detailTicket?.affiliationOrganization,
                        statusDetail?.workflow
                    )
                        .then(statusItems => {
                            if (!Utils.isEmptyArray(statusItems)) {
                                const selectedStatusNo = currentPanelInitDataRes?.argsAll?.statusNo ?? 0;
                                const selectedDraftStatusDetail = statusItems?.find(statusItem => {
                                    const statusStructure = Utils.convertJSONDataToObject(statusItem?.structure);
                                    const statusNo = Number(statusStructure?.no);
                                    return statusNo === selectedStatusNo;
                                });
    
                                if (!Utils.isEmptyObject(selectedDraftStatusDetail)) {
                                    statusDetail = Utils.convertJSONDataToObject(
                                        selectedDraftStatusDetail
                                    );
                                    const statusStructure = Utils.convertJSONDataToObject(statusDetail?.structure)
                                    cloneCurrentPanelInitData.ticketStatus = {
                                        ...statusDetail,
                                        name: Utils.getTextByLanguage(
                                            Constant.LANGUAGE_TYPE.JP,
                                            statusDetail.name
                                        ),
                                        background: statusStructure?.helpdesk?.background,
                                        color: statusStructure?.helpdesk?.color
                                    };
                                }
                            }
                        })
                        .catch(err => {
                            console.log('getItemFieldListByFieldId err :', err );
                        })
                        .finally(() => {
                            argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
                            argsAll.setTriggerSaveFormData(Date.now().toString())
                        });
                    return;
                }
                cloneCurrentPanelInitData.ticketStatus = {
                    ...statusDetail,
                    name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, statusDetail.name),
                    background: statusDetail?.structure?.helpdesk?.background,
                    color: statusDetail?.structure?.helpdesk?.color
                };
            }

            argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
        }
        argsAll.setTriggerSaveFormData(Date.now().toString());
    }

    // Init data for ticket invite external customer
    if (argsAll.draftData?.externalProjectInfo) {
        let externalProjectInfo = Utils.convertJSONDataToObject(argsAll.draftData.externalProjectInfo);
        if (!Utils.isEmptyObject(externalProjectInfo)) {
            // Text display
            let projectName = '';
            let corporationName = '';
            let corporationId;
            let projectId;
            if (externalProjectInfo.projectCustomer && !Utils.isEmptyObject(externalProjectInfo.projectCustomer)) {
                projectId = externalProjectInfo.projectCustomer.id;
                projectName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, externalProjectInfo.projectCustomer.name);
            }
            if (externalProjectInfo.corporationCustomer && !Utils.isEmptyObject(externalProjectInfo.corporationCustomer)) {
                corporationId = externalProjectInfo.corporationCustomer.id;
                corporationName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, externalProjectInfo.corporationCustomer.name);
            }
            let textDisplay = `${projectName} (${corporationName})`;
            argsAll.setExternalCustomerRequestKeyword(textDisplay);

            // Customer project info
            let customerInfo = {
                corporationId,
                label: textDisplay,
                value: projectId,
            }

            if (
                currentPanelInitDataRes?.isEditedData &&
                !Utils.isEmptyObject(
                    currentPanelInitDataRes?.argsAll?.externalCustomerRequestProject
                )
            ) {
                customerInfo = currentPanelInitDataRes?.argsAll?.externalCustomerRequestProject;
            }

            argsAll.setExternalCustomerRequestProject(customerInfo);
        }
    }

    // Init for ticket notice
    if (
        ticketType === Constant.TICKET_TYPE.BROADCAST_PARENT ||
        ticketType === Constant.TICKET_TYPE.BROADCAST_CHILD
    ) {
        /**
         * get value after change tab and go back. start
         */
        const keysOfMultipleTargetNotice = Object.keys(Constant.NOTICE_ALL_CUSTOMER);
        const valuesOfMultipleTargetNotice = Object.values(Constant.NOTICE_ALL_CUSTOMER)
        const idxOfTargetNotice = valuesOfMultipleTargetNotice.indexOf(currentPanelInitDataRes?.formData?.noticeCustomer)
        const selectedKeyMultipleTargetNotice = keysOfMultipleTargetNotice[idxOfTargetNotice]
        /**
         * get value after change tab and go back. end
         */
        let noticeCustomer = selectedKeyMultipleTargetNotice || detailTicket.customer; 

        if (
            [
                Constant.NOTICE_GROUP_CUSTOMER.ALL_CUSTOMER_PROJECT,
                Constant.NOTICE_GROUP_CUSTOMER.ALL_GUEST_CUSTOMER_USER,
                Constant.NOTICE_GROUP_CUSTOMER.ALL_GENERAL_PROJECT,
                Constant.NOTICE_GROUP_CUSTOMER.ALL_USER_IN_BASE_PROJECT
            ].includes(noticeCustomer)
        ) {
            let noticeCustomerValue = argsAll.listOptionsNoticeMultiCustomer.find(
                option => option.id === noticeCustomer
            );
            if (noticeCustomerValue) {
                argsAll.setNoticeCustomer(noticeCustomerValue.value);
            }
            argsAll.setMethodNotice(1);
        } else {
            argsAll.setNoticeCustomer(noticeCustomer);
            argsAll.setMethodNotice(0);
        }
    }

    // status field
    if (argsAll.setStatusNo) {
        argsAll.setStatusNo(oldArgsAll?.statusNo || 0);
    }
    argsAll.setTriggerSaveStateData(Date.now().toString());
    argsAll.setIsEdited(currentPanelInitDataRes?.isEditedData ?? false);
};

export const createTaskTicketHandler = async (
    formData,
    userDetail,
    panelId,
    panelType,
    tabId,
    corporationDetail,
    selectedForm,
    fieldListData,
    argsAll,
) => {
    // check selectedForm
    if (Utils.isEmptyString(selectedForm)) {
        argsAll.setIsErrorSelected(true);
        return;
    }

    argsAll.setIsLoading(true);

    // convert field to request body
    let fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData);
    let statusField = fieldListData.find(
        (field) => field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
    );
    let status = '';
    if (!Utils.isEmptyObject(statusField)) {
        status = statusField.id;
    }

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
        argsAll.fileUploadList
    );


    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    let requestBody = {
        createTicketRequestDto: {
            corporationOrigin: corporationDetail.id,
            createUserId: userDetail.id,
            projectOrigin: argsAll.projectInuseDetail.id,
            corporationTarget: corporationDetail.id,
            ticketType: Constant.TICKET_TYPE.TASK,
            affiliationOrganization: corporationDetail.id,
            affiliationProject: argsAll.projectInuseDetail.id,
            projectTarget: [argsAll.projectInuseDetail.id],
            customer: argsAll.projectInuseDetail.id,
            status: status,
            statusNo: Number(argsAll?.statusNo),
            fields: fields,
            type: argsAll.selectedForm,
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            creator: userDetail.id,
            personInCharge: argsAll.selectedAssigneeUserId ? argsAll.selectedAssigneeUserId : '',
            ...draftTicketInfo
        },
    };

    //call API create ticket
    let newTicket = await createNewTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        if (!newTicket.createTicketStatus && newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            // Reload
            argsAll.setIsOpenModalReloadPage(true);
        }
        
        argsAll.setIsLoading(false);
        return;
    }
    
    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_TASK,
        formId: argsAll?.selectedForm,
        projectTargetId: formData?.projectTarget,
        corpTargetId: formData?.corporationTarget ? formData?.corporationTarget : corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);
    argsAll.setIsLoading(false);
    if (!tabId) {
        tabId = argsAll.ticketId;
    }

    // Create Kibana log
    let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
    let usingFormName = Utils.convertJSONDataToObject(argsAll.selectedFormInfo.name)?.jp?.text;
    let dataLog = {
        rootCorporationDetail: argsAll.corporationDetail,
        rootProjectDetail: argsAll.projectInuseDetail,
        corporationDetail: argsAll.corporationDetail,
        projectDetail: argsAll.projectInuseDetail,
        userDetail: argsAll.userDetail,
        ticketDetail: {
            id: newTicket.id,
            outline: newTicket.outline,
            creator: newTicket.creator,
            usingFormName: usingFormName,
            createdAt: newTicket.createdAt
        },
        metaData: {
            formDetailId: argsAll.selectedForm,
            ticketType: Constant.TICKET_TYPE.TASK
        },
        ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.SOLUTIONDESK
    }

    let logKibanaData = createKibanaDataContentOperation(
        lastUserAction,
        dataLog
    );
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
        logKibanaData: logKibanaData
    };
    createKibanaLogAPI(argsAll.API, param);
    argsAll.setLastUserAction(null);

    removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);

    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        API: argsAll.API,
    });

    argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-CM-SEND-TICKET-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
    return newTicket;
};

const draftTaskTicketHandler = async (
    formData,
    userDetail,
    corporationDetail,
    selectedForm,
    fieldListData,
    argsAll,
) => {
    try {
        // check selectedForm
        if (Utils.isEmptyString(selectedForm)) {
            argsAll.setIsErrorSelected(true);
            return null;
        }

        argsAll.setIsLoading(true);

        // convert field to request body
        let fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData);
        let statusField = fieldListData.find(
            (field) => field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
        );
        let status = '';
        if (!Utils.isEmptyObject(statusField)) {
            status = statusField.id;
        }

        let uploadFileS3Result = {
            fileListSuccess: [],
            suffixOfAttachments: {},
            listFileError: []
        };
        
        uploadFileS3Result = await handleUploadFilesForTicket(
            formData,
            argsAll.setFileUploading,
            argsAll.fileUploadList
        );

        let draftTicketInfo = {
            isSendDraft: argsAll?.isDraft ? true : false,
            fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
            oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
        };

        let requestBody = {
            createTicketRequestDto: {
                corporationOrigin: corporationDetail.id,
                createUserId: userDetail.id,
                projectOrigin: argsAll.projectInuseDetail.id,
                corporationTarget: corporationDetail.id,
                ticketType: Constant.TICKET_TYPE.TASK,
                affiliationOrganization: corporationDetail.id,
                affiliationProject: argsAll.projectInuseDetail.id,
                projectTarget: [argsAll.projectInuseDetail.id],
                customer: argsAll.projectInuseDetail.id,
                status: status,
                statusNo: Number(argsAll?.statusNo),
                fields: fields,
                type: argsAll.selectedForm,
                liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
                public: Constant.TICKET_PUBLIC.DRAFT,
                fileListSuccess: uploadFileS3Result.fileListSuccess,
                suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
                creator: userDetail.id,
                personInCharge: argsAll.selectedAssigneeUserId ? argsAll.selectedAssigneeUserId : '',
                ...draftTicketInfo
            },
        };

        //call API create ticket
        let newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);

        if (!newTicket?.id) {
            if (!newTicket.createTicketStatus && newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
                // Reload
                argsAll.setIsLoading(false);
                argsAll.setIsOpenModalReloadPage(true);
            }
            return null;
        }

        let dataUpdateLastForm = {
            typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_TASK,
            formId: argsAll?.selectedForm,
            projectTargetId: formData?.projectTarget,
            corpTargetId: formData?.corporationTarget ? formData?.corporationTarget : corporationDetail?.id
        }
    
        await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);
        argsAll.setIsLoading(false);
        return newTicket;
    } catch (error) {
        console.log('draftTaskTicketHandler error >>>', error);
        return null;
    }
}


/**
 * createEmailTicketHandler
 * @param {*} formData 
 * @param {*} userDetail 
 * @param {*} panelId 
 * @param {*} panelType 
 * @param {*} tabId 
 * @param {*} corporationDetail 
 * @param {*} selectedForm 
 * @param {*} fieldListData 
 * @param {*} argsAll 
 * @returns 
 */
export const createEmailTicketHandler = async (
    formData,
    userDetail,
    panelId,
    panelType,
    tabId,
    corporationDetail,
    selectedForm,
    fieldListData,
    argsAll,
) => {
    // check selectedForm
    if (Utils.isEmptyString(selectedForm)) {
        argsAll.setIsErrorSelected(true);
        return;
    }

    let toList = processEmailAddressList(argsAll.toEmailAddressList);
    let ccList = processEmailAddressList(argsAll.ccEmailAddressList);
    let bccList = processEmailAddressList(argsAll.bccEmailAddressList);

    if (Utils.isEmptyArray(argsAll.toEmailAddressList) || Utils.isEmptyArray(toList)) {
        return;
    }

    argsAll.setIsLoading(true);

    // convert field to request body
    let fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData);
    
    fields = Utils.convertJSONDataToObject(fields);
    // Update more field value;
    if (!Utils.isEmptyArray(argsAll.fieldListData)) {
        argsAll.fieldListData.forEach(fieldDetail => {
            switch(fieldDetail?.sysField) {
                case Constant.SYS_FIELD.TO:
                    fields[fieldDetail.id] = toList;
                    break; 
                case Constant.SYS_FIELD.CC:
                    fields[fieldDetail.id] = ccList;
                    break; 
                case Constant.SYS_FIELD.BCC:
                    fields[fieldDetail.id] = bccList;
                    break; 
                case Constant.SYS_FIELD.MAIL_BODY:
                    /**
                     * content mail body in Richtext component it converted to json.
                     * we don't need json. so convert it from json to normal text in here
                     */
                    fields[fieldDetail.id] = Utils.isJson(formData[fieldDetail?.id])
                        ? JSON.parse(formData[fieldDetail?.id])
                        : formData[fieldDetail?.id];
                    break;
                default:
                    return
        
            }
        })
    }

    let statusField = fieldListData.find(
        (field) => field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
    );
    let status = '';
    if (!Utils.isEmptyObject(statusField)) {
        status = statusField.id;
    }

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, JSON.stringify(fields), argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
        argsAll.fileUploadList
    );


    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    let requestBody = {
        createTicketRequestDto: {
            corporationOrigin: corporationDetail.id,
            createUserId: userDetail.id,
            projectOrigin: argsAll.projectInuseDetail.id,
            corporationTarget: corporationDetail.id,
            ticketType: Constant.TICKET_TYPE.EMAIL,
            affiliationOrganization: corporationDetail.id,
            affiliationProject: argsAll.projectInuseDetail.id,
            projectTarget: [argsAll.projectInuseDetail.id],
            customer: argsAll.projectInuseDetail.id,
            status: status,
            statusNo: Number(argsAll?.statusNo),
            fields: JSON.stringify(fields),
            type: argsAll.selectedForm,
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            creator: userDetail.id,
            personInCharge: argsAll.selectedAssigneeUserId ? argsAll.selectedAssigneeUserId : '',
            isDeliver: true,
            deleteOldTicketId: argsAll?.deleteOldTicketId ? argsAll?.deleteOldTicketId : '',
            ...draftTicketInfo
        },
    };

    //call API create ticket
    let newTicket = await createNewTicketAPI(argsAll.API, requestBody);
    await Utils.delay(1000);
    if (!newTicket?.id) {
        if (!newTicket.createTicketStatus && newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            // Reload
            argsAll.setIsOpenModalReloadPage(true);
        }
        
        argsAll.setIsLoading(false);
        return;
    }
    
    argsAll.setIsLoading(false);
    
    const isUpdatePanelAfterCreatedTicket = argsAll?.isUpdatePanelAfterCreatedTicket ?? true
    
    if (isUpdatePanelAfterCreatedTicket) {
        if (!tabId) {
            tabId = argsAll.ticketId;
        }
        argsAll.setLastUserAction(null);
    
        removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);
    
        argsAll.updatePanelAfterCreateTicket({
            panelId: panelId,
            tabId: tabId,
            panelType: panelType,
            ticketId: newTicket.id,
            ticketOutline: newTicket.outline,
            API: argsAll.API,
            isEmailTicket: true,
            isDetailEmailTicket: true
        });
    }

    argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-CM-SEND-TICKET-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
    return newTicket;
};


function processEmailAddressList(emailAddressList) {
    let emailList = [];
    if (!Utils.isEmptyArray(emailAddressList)) {
        for (let emailElement of emailAddressList) {
            if (emailElement.projectId) {
                let userList = emailElement?.userList;
                if (userList.every(user => !user.selected)) {
                    continue
                };
                emailList.push(emailElement);
            } else {
                emailList.push(emailElement);
            }
        }
    }

    return emailList;
}

const draftEmailTicketHandler = async (
    formData,
    userDetail,
    corporationDetail,
    selectedForm,
    fieldListData,
    argsAll,
) => {
    try {
        // check selectedForm
        if (Utils.isEmptyString(selectedForm)) {
            argsAll.setIsErrorSelected(true);
            return null;
        }

        let toList = processEmailAddressList(argsAll.toEmailAddressList);
        let ccList = processEmailAddressList(argsAll.ccEmailAddressList);
        let bccList = processEmailAddressList(argsAll.bccEmailAddressList);

        // if (Utils.isEmptyArray(argsAll.toEmailAddressList) || Utils.isEmptyArray(toList)) {
        //     return;
        // }

        argsAll.setIsLoading(true);

        // convert field to request body
        let fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData);
        fields = Utils.convertJSONDataToObject(fields);
        // Update more field value;
        if (!Utils.isEmptyArray(argsAll.fieldListData)) {
            argsAll.fieldListData.forEach(fieldDetail => {
                switch(fieldDetail?.sysField) {
                    case Constant.SYS_FIELD.TO:
                        fields[fieldDetail.id] = toList;
                        break; 
                    case Constant.SYS_FIELD.CC:
                        fields[fieldDetail.id] = ccList;
                        break; 
                    case Constant.SYS_FIELD.BCC:
                        fields[fieldDetail.id] = bccList;
                        break; 
                    // case Constant.SYS_FIELD.ATTACHMENTS:
                    //     attachmentsList = fieldData;
                    //     break;
                    default:
                        return
            
                }
            })
        }
        let statusField = fieldListData.find(
            (field) => field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
        );
        let status = '';
        if (!Utils.isEmptyObject(statusField)) {
            status = statusField.id;
        }

        let uploadFileS3Result = {
            fileListSuccess: [],
            suffixOfAttachments: {},
            listFileError: []
        };
        
        uploadFileS3Result = await handleUploadFilesForTicket(
            formData,
            argsAll.setFileUploading,
            argsAll.fileUploadList
        );

        let draftTicketInfo = {
            isSendDraft: argsAll?.isDraft ? true : false,
            fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
            oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
        };

        let requestBody = {
            createTicketRequestDto: {
                corporationOrigin: corporationDetail.id,
                createUserId: userDetail.id,
                projectOrigin: argsAll.projectInuseDetail.id,
                corporationTarget: corporationDetail.id,
                ticketType: Constant.TICKET_TYPE.EMAIL,
                affiliationOrganization: corporationDetail.id,
                affiliationProject: argsAll.projectInuseDetail.id,
                projectTarget: [argsAll.projectInuseDetail.id],
                customer: argsAll.projectInuseDetail.id,
                status: status,
                statusNo: Number(argsAll?.statusNo),
                fields: JSON.stringify(fields),
                type: argsAll.selectedForm,
                liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
                public: Constant.TICKET_PUBLIC.DRAFT,
                fileListSuccess: uploadFileS3Result.fileListSuccess,
                suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
                creator: userDetail.id,
                personInCharge: argsAll.selectedAssigneeUserId ? argsAll.selectedAssigneeUserId : '',
                ...draftTicketInfo
            },
        };

        //call API create ticket
        let newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);

        if (!newTicket?.id) {
            if (!newTicket.createTicketStatus && newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
                // Reload
                argsAll.setIsLoading(false);
                argsAll.setIsOpenModalReloadPage(true);
            }
            return null;
        }

        argsAll.setIsLoading(false);
        return newTicket;
    } catch (error) {
        console.log('ERROR _ draftEmailTicketHandler: ', error);
        return null;
    }
}
